import React, { useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate} from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { loginUser } from "../utils/login";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please fill in both fields");
      return;
    }
    setLoading(true);
    setError("");

    try {
      const response = await loginUser({ email, password });

      const { token } = response.data;

      // Save token in localStorage
      localStorage.setItem("authToken", token);

      // Decode the token to get expiry time
      const decoded = jwtDecode(token);
      const expiryTime = decoded.exp * 1000;
      localStorage.setItem("tokenExpiry", expiryTime.toString());

      navigate("/dashboard");
    } catch (err) {
      setError(
        err.response?.data?.message || "Invalid credentials or server error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0C1832] px-4 sm:px-6 md:px-10">
      <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-xl shadow-2xl p-6 sm:p-8 md:p-10 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl border border-gray-100/10 relative z-10">
        <div className="absolute -inset-1 rounded-xl bg-gradient-to-br opacity-25 blur-xl"></div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="relative z-10">
          <div className="flex flex-col items-center mb-6">
            <img
              src="/logo-with-name.webp"
              alt="Logo"
              className="h-8 sm:h-10 mb-4"
            />
            <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-wide">
              Login
            </h2>
          </div>

          {error && (
            <p className="text-red-400 text-center mb-4 text-sm">{error}</p>
          )}

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-4 px-4 py-2 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20 text-sm sm:text-base"
          />

          <div className="relative mb-6">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 pr-10 rounded bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C1832] backdrop-blur border border-white/20"
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white cursor-pointer"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 bg-gradient-to-r from-[#0C1832] to-[#1F2C4C] text-white rounded hover:brightness-110 transition-all duration-200 shadow-md mb-3 disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          {/* <p className="text-sm text-center text-white">
            Don’t have an account?{" "}
            <Link
              to="/register"
              className="text-blue-300 hover:underline font-medium"
            >
              Register
            </Link>
          </p> */}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
